import TrendingNow from '../modules/TrendingNow';
import Revealer from '../modules/Revealer';
import '../web-components/mobile-hp-nav';
import '../web-components/store-location-with-map';
const startIndex = () => {
    console.log('UNTUCKit : Template : IndexTemplate');
    TrendingNow.init();
    Revealer.init();
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startIndex, { once: true });
}
else {
    startIndex();
}
